'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msActivitySkipButton', msActivitySkipButton);

  msActivitySkipButton.$inject = ['$parse', 'activityRouter'];

  /* @ngInject */
  function msActivitySkipButton($parse, activityRouter) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs) {
      element.on('click keyup', function (event) {
        // 13 == 'enter', 32 == 'spacebar'
        var triggerKeyCodes = [13, 32];
        // Allow the user to press "enter" or "space" to activiate this button.
        if (event.keyCode && !triggerKeyCodes.includes(event.keyCode)) {
          return;
        }
        skipHide();
      });

      // If it is an anchor, give it an empty href (makes it focusable)
      if (element[0].tagName === 'A' && !element[0].getAttribute('href')) {
        element[0].setAttribute('href', '');
      }
      // Otherwise, make it act like a button.
      else {
          element[0].setAttribute('tabindex', 0);
          element[0].setAttribute('role', 'button');
        }

      function skipHide() {
        var activity = $parse(attrs.msActivitySkipButton)(scope);
        activityRouter.skipActivity(activity, attrs.hide, attrs.reason);
      }
    }
  }
})();